import { ActivatedRoute, Params } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { switchMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UserInfo } from 'firebase';
import * as AOS from 'aos';

import { AuthenticationService } from 'src/app/auth/fire-auth/authentication.service';
import { FeedService } from 'src/app/core/feed/services/feed.service';
import { Status } from './../../constants';
import { User } from 'src/app/models/user';
import { UserfirestoreService } from 'src/app/auth/fire-store/userfirestore.service';

@Component({
  selector: 'makaw-public-profile',
  templateUrl: './public-profile.component.html',
})
export class PublicProfileComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject();
  public posts$;
  public friend: User;
  public currentUser: User;
  public status = Status.Friend;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly angularFireAuth: AngularFireAuth,
    private readonly authenticationService: AuthenticationService,
    private readonly feedService: FeedService,
    private readonly userService: UserfirestoreService
  ) {}

  ngOnInit() {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
    });

    this.angularFireAuth.authState
      .pipe(
        switchMap((status: UserInfo) => {
          console.log(status);
          return this.userService.getUserById(status.uid).valueChanges();
        }),
        switchMap((currentUser: User) => {
          this.currentUser = currentUser;
          console.log('currentUser', currentUser);
          return this.activatedRoute.params;
        }),
        switchMap((response: Params) =>
          this.userService.getUserById(response.id).valueChanges()
        ),
        switchMap((friend: User) => {
          this.friend = friend;
          return (this.posts$ = this.feedService.getUserPost(friend.uid));
        }),
        takeUntil(this.destroyed$)
      )
      .subscribe();
  }
  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
